import React from "react";
import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsReact from "highcharts-react-official";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";

// if (typeof Highcharts === "object") {
//   Highcharts3D(Highcharts);
// }

const MonthlyGenerationChart = ({ monthWiseData }) => {
  const { getText } = useLanguageTranslation();

  const getXAxisData = (chartData) => {
    if (!Array.isArray(chartData)) {
      return [];
    }
    return chartData.map(
      (item) => item?.field_monthly_generation_with_ye ?? "No Data"
    );
  };

  const getYAxisData = (chartData) => {
    if (!Array.isArray(chartData)) {
      return [];
    }
    return chartData.map(
      (item) => item?.field_monthly_generation_mu ?? "No Data"
    );
  };
  const xaxisData = getXAxisData(monthWiseData);
  const yaxisData = getYAxisData(monthWiseData);

  const options = {
    chart: {
      type: "column",
      options3d: {
        enabled: true,
        // alpha: 35,
        beta: 0,
        depth: 75,
        viewDistance: 125,
      },
    },
    title: {
      text: getText("Monthly Generation MU", "एमयू में मासिक पीढ़ी"),
      align: "left",
    },
    xAxis: {
      // categories: yearsData,
      categories: xaxisData,
      title: {
        text: "Month",
      },
      // labels: {
      //   step: 1, // Ensures every label is displayed
      //   formatter: function () {
      //     // Customize label formatting if needed
      //     return this.value;
      //   },
      //   rotation: -45, // Rotates labels for better readability
      //   style: {
      //     fontSize: "12px", // Adjust font size if labels are too cluttered
      //   },
      // },
    },

    yAxis: {
      min: 0,
      tickInterval: 800,
      title: {
        text: getText("Generation (MU)", "उत्पादन(एमयू)"),
      },
    },
    tooltip: {
      headerFormat: "<b>{point.key}</b><br>",
      pointFormat: "Generation: {point.y} MU",
      shared: true,
      useHTML: true,
      valueDecimals: 3,
    },
    plotOptions: {
      column: {
        depth: 40,
      },
    },
    series: [
      {
        name: getText("Monthly Generation MU", "मासिक उत्पादन(एमयू)"),
        data: yaxisData,
        colorByPoint: true,
        //   colors: ["brown"],
      },
    ],
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default MonthlyGenerationChart;
